<template>
  <div>
    <div class="main-div dialog-scroll">

      <el-dialog
        width="800px"
        height="786px"
        :title="$t('label.system.pointInvalidationUserPointPopup.pageTitle')+ holderName"
        :before-close="handleClose"
        :visible.sync="userPointSearchFlg"
      >
        <el-table
          class="table-type"
          :data="result">

          <!--  年月 -->
          <el-table-column
            label="有効期限"
            class-name="col-4">
            <div slot-scope="scope">
                <span>
                  {{ scope.row.endDate | dateFormat }}
                </span>
            </div>
          </el-table-column>

          <!--  ユーザーポイント残高 -->
          <el-table-column
            prop="balance"
            class-name="col-4"
            :label="pointTypeName+'残高'"/>

          <!--  失効ポイント設定 -->
          <el-table-column class-name="col-7" :label="$t('label.system.pointInvalidationUserPointPopup.result.invalidAmount')">
            <div slot-scope="scope" class="detail-button with-100">
                <number-input-medium :value="invalidAmounts[scope.$index]" @in_put="getInputNumber($event,scope.row,scope.$index)"/>
            </div>
          </el-table-column>

          <!-- 失効処理後ポイント残高 -->
          <el-table-column
            class-name="col-3"
            :label="$t('label.system.pointInvalidationUserPointPopup.result.afterUpdatedPoint')">
            <div slot-scope="scope">
                <span :class="{color: scope.row.invalidAmount > 0}">
                  {{Number(scope.row.balance) - Number(scope.row.invalidAmount) | filter}}
                </span>
            </div>
          </el-table-column>

        </el-table>
        <div class="btn-center">
          <div class="btn-content">
            <sp-smart-button :disabled= isDisabled :disable= isDisabled @click="confirm" class="btn-confirm">{{$t("label.system.pointInvalidationUserPointPopup.result.buttonSet")}}</sp-smart-button>
            <cancel-narrow-down class="link-primary" @click="cancel">{{$t("button.common.data.cancel")}}</cancel-narrow-down>
          </div>
        </div>



      </el-dialog>
    </div>
        <pointInvalidPopup
          :centerDialogVisibleParam.sync = "centerDialogVisibleIsShow"
          @on-isPassParam ="comfirmUpdateToSystem"
        >
        </pointInvalidPopup>

        <pointInvalidConfirmPopup
          :confirmPopupFlg.sync = "confirmPopupFlg"
          @comfirmPopup = "comfirmPopup"
        >
        </pointInvalidConfirmPopup>
        <loading-dialog :dialogVisible="loading" />
  </div>
  <!-- 路由到前一个画面 -->
</template>

<script>
import LoadingDialog from "@/components/common/loading/LoadingDialog";
import SpSmartButton from "@/components/common/sp-smart-button"
import NumberInputMedium from "@/components/common/input/NumberInput"
import moment from 'moment'
import SystemManageApi from "@/api/SystemManageApi";
import errorCodeMsg from "@/utils/error-code-msg"
import statusErrorCodeMsg from "@/utils/status-error-msg"
import pointInvalidPopup from "@/components/system/popup/PointInvalidPopup"
import pointInvalidConfirmPopup from "@/components/system/popup/PointInvalidConfirmPopup"
import cancelNarrowDown from "@/components/common/generalButton/CancelNarrowDown";
// import moment from 'moment';
// import elDialogPrompt from "@/components/common/el-dialog-prompt"

export default {
  components: {
    LoadingDialog,
    pointInvalidPopup,
    pointInvalidConfirmPopup,
    SpSmartButton,
    NumberInputMedium,
    cancelNarrowDown
    //elDialogPrompt,
  },
  name: "UserPointInvalidEditPoput",
  props: {
    result: Array,
    holderName:String,
    walletId:String,
    userPointSearchFlg: {
      type: Boolean,
      default: false
    },
    isBack: String,
    pointType:{
      type:String,
      default:null
    },
    pointTypeName:{
      type:String,
      default:''
    }
  },
  data() {
    return {
      invalidAmounts:[0,0,0,0,0,0],
      isDisabled: false,
      loading : false,
      confirmPopupFlg : false,
      centerDialogVisibleIsShow: false,
      response : [],
    };
  },
  filters: {
    dateFormat (value) {
      if (value !== null && value !== undefined) {
        value = moment(value).format("YYYY年M月D日") + 'まで'
        return value
      }
    },
    filter(value) {
      if(value > 0){
        return value;
      }else
        return 0;
    }
  },
  methods: {
    updateDisable(){
      this.isDisabled = true
    },
    confirm(){
      if(this.isBack == "one"){
        this.$emit("update:userPointSearchFlg", false);
        this.checkInvaildAmount()
        this.$emit("UserInvalidEditBack",this.walletId,this.result)
        this.invalidAmounts = [0,0,0,0,0,0]
      }else if(this.isBack == "top"){
        this.checkInvaildAmount()
        this.formatResult()
        this.centerDialogVisibleIsShow = true
      }
    },
    comfirmUpdateToSystem(){
      this.loading = true
      this.updateToSystem()
    },
    formatResult(){
      this.response = [];
      this.response.push({
        walletId: this.walletId,
        pointInvalidationList: this.result
      })
    },
    checkInvaildAmount(){
      this.result.forEach(data =>{
        if(data.invalidAmount > data.balance){
          data.invalidAmount = data.balance
        }
      })
    },
    updateToSystem(){
      SystemManageApi.pointWalletDetailInvalidation({
          walletType: this.pointType,
          PointInvalidationBodyList: this.response
        })
        .catch((error) => {
          errorCodeMsg(error, this)
        })
        .then(({ data }) => {
          if(!statusErrorCodeMsg(data.statusCode, this)) {
            return;
          }
          this.confirmPopupFlg = true
      })
        .finally(() => {
            this.loading = false
      });
    },
    comfirmPopup(){
      this.$emit("update:userPointSearchFlg", false);
      this.$emit("initialization")
      this.invalidAmounts = [0,0,0,0,0,0]
    },
    cancel(){
      this.handleClose()
    },
    handleClose() {
      this.invalidAmounts = [0,0,0,0,0,0]
      this.$emit("update:userPointSearchFlg", false);
    },
    getInputNumber(value,row,index){
      if(this.userPointSearchFlg){
        this.invalidAmounts[index] = value
        this.$set(
          this.result,
          index,
          {
            yearMonth: row.yearMonth,
            endDate: row.endDate,
            balance: row.balance,
            invalidAmount:Number(value)
          }
        )
        if(this.isBack == "top"){
          this.isDisabled = true
          this.result.forEach(data => {
            if(data.invalidAmount > 0 && data.balance > 0){
              this.isDisabled = false
            }
          })
        }
      }
    },
    formatDate(date){
      return date;
    },
    AddMonth(value){
      let date = moment(new Date()).format("YYYY/MM")
      var str = date.split("");
      var year = parseInt(str[0] + str[1] + str[2] + str[3]);
      var month = parseInt(str[5] + str[6]);
      month = month + value;

      if(month > 12){
          month = month - 12;
          year = year +1;
      }
      return year + "年 " + month + "月";
    },
  },
};
</script>

<style lang="scss" scoped>
.color {
  color: #329CA6;
}
.main-div{

  .text-align {
    text-align: center;
  }
  .underthe {
    padding-bottom: 20px;
  }

  .Buttonstyle {
    background: #fff;
    color: #007feb;
    border: 1px solid #007feb;
  }
  .span-wrap-size-color {
    width: 300px;
    color: #525250;
    font-size: 16px;
    text-align: left;
    display: block;
    word-break: normal;
    word-wrap: break-word;
    overflow: hidden;
  }
  ::v-deep .el-dialog {
    padding-left: 20px;
    padding-right: 20px;
  }
  ::v-deep .el-dialog__header {
    text-align: left;
    margin-top: 24px;
    margin-bottom: 24px;
  }
  ::v-deep .el-form-item__label {
    color: #525250 !important;
    font-size: 16px !important;
  }
  ::v-deep .el-radio {
    color: #2699FB;
  }
  .text-left {
    text-align: left;
    color: #525250;
    font-size: 16px;
  }
  ::v-deep .el-dialog__header .el-dialog__title {
    font-size: 24px !important;
    font-weight: initial !important;
    color: #525250 !important ;
  }
  ::v-deep .el-icon-close:before {
    display: none;
  }
  ::v-deep .el-dialog {
    min-width: 664px !important;
  }
  ::v-deep .el-radio__label {
    font-size: 16px;
    color:#525250;
  }
  ::v-deep .is-checked .el-radio__label {
    font-size: 16px;
    color:#525250;
  }
  .setting-button {
    margin-top: 50px;
    height: 40px;
    width: 296px;
  }
  .float-left {
    float: left;
  }
  .div-width {
    width: 200px;
  }
}

.prompt-div >.logout-style{
  ::v-deep .el-dialog {
    height: 164px;
    border-radius: 3px;
  }
}

.btn-center{
  padding-top: 35px;
  margin: 0 auto;
  text-align: center;
  display: table;
  width: 296px;
	height: 80px;
}
.btn-content{
  display: table-cell;
	vertical-align: middle;
	text-align: center;
}
.btn-confirm{
  font-size: 13px;
  width: 296px;
  height: 40px;
  margin-bottom: 21px;
}
.link-primary{
  font-size: 13px;
}
::v-deep .el-table th{
  padding: 0px;
}
::v-deep .el-table__header .cell {
  white-space: pre-line;
}
::v-deep .el-table .cell{
  font-size: 12px;
  padding-left: 0px;
}
::v-deep .sp_unit{
  padding-top: 15px;
  padding-left: 12px;
}
::v-deep .el-table td{
  padding: 13px 0 !important;
}
.my-button.is-disabled{
    color: #B8B8B4;
    background-color: #F2F2ED;
}


</style>
